import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { faqItemDtoSchema, type FaqItemDto } from '@tg-hookah/shared/dto';
import { api } from '@/lib/api';

const listSchema = z.array(faqItemDtoSchema);

async function fetchFaq(): Promise<FaqItemDto[]> {
  const res = await api.get('/faq');
  return listSchema.parse(res.data);
}

export function useFaq() {
  return useQuery({ queryKey: ['faq'], queryFn: fetchFaq });
}
